export default function alertWidget(editor) {
  editor.DomComponents.addType('eb-alert', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-alert'
    },
    model: {
      defaults: {
        name: 'Alert',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-alert', 'data-alert-type': 'info' },
        style: {
          'padding': '16px 20px',
          'border-radius': '6px',
          'border-left': '4px solid #667eea',
          'background-color': '#f0f3ff',
          'display': 'flex',
          'align-items': 'flex-start',
          'gap': '12px',
        },
        components: `
          <div style="font-size:20px;color:#667eea;flex-shrink:0;margin-top:2px;"><i class="fa fa-info-circle"></i></div>
          <div>
            <h4 style="font-size:15px;font-weight:600;color:#333;margin:0 0 4px;">This is an informational alert</h4>
            <p style="font-size:14px;color:#555;margin:0;line-height:1.6;">Alert description goes here. You can add any text to provide more details.</p>
          </div>
        `,
        traits: [
          {
            type: 'select', name: 'data-alert-type', label: 'Alert Type', changeProp: true,
            options: [
              { id: 'info', label: 'Info' },
              { id: 'success', label: 'Success' },
              { id: 'warning', label: 'Warning' },
              { id: 'danger', label: 'Danger' },
            ],
          },
          { type: 'checkbox', name: 'data-dismissible', label: 'Dismissible' },
        ],
      },
      init() {
        this.on('change:attributes:data-alert-type', this.updateAlertStyle)
      },
      updateAlertStyle() {
        const type = this.getAttributes()['data-alert-type'] || 'info'
        const colors = {
          info: { border: '#667eea', bg: '#f0f3ff', icon: 'fa-info-circle' },
          success: { border: '#28a745', bg: '#f0fff4', icon: 'fa-check-circle' },
          warning: { border: '#ffc107', bg: '#fffcf0', icon: 'fa-exclamation-triangle' },
          danger: { border: '#dc3545', bg: '#fff5f5', icon: 'fa-times-circle' },
        }
        const c = colors[type] || colors.info
        this.setStyle({
          ...this.getStyle(),
          'border-left': `4px solid ${c.border}`,
          'background-color': c.bg,
        })
        const iconEl = this.components().at(0)
        if (iconEl) {
          iconEl.setStyle({ ...iconEl.getStyle(), color: c.border })
          iconEl.components(`<i class="fa ${c.icon}"></i>`)
        }
      },
    },
  })

  editor.BlockManager.add('eb-alert', {
    label: 'Alert',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"/></svg>',
    content: { type: 'eb-alert' },
  })
}
